import { useIntl } from 'react-intl';
import React from 'react';
import { insertLinkIntoMessage } from '../../../util';
import styles from './DSADisplay.module.scss';

export const DSADisplay = (props: {
    eventId: string;
    eventName: string;
    eventUrl: string;
}) => {
    const { eventId, eventName, eventUrl } = props;
    const intl = useIntl();
    const illegalContentUrlTest = `https://ebrite-testing.nima.tremau.net/user-reports/?content.content_id=${eventId}&content.title=${eventName}&content.url=${eventUrl}&content.customerSpecific.entityId=${eventId}&content.type.id=IFRAME`;
    const illegalContentUrlProd = `https://ebrite.nima.tremau.net/user-reports/?content.content_id=${eventId}&content.title=${eventName}&content.url=${eventUrl}&content.customerSpecific.entityId=${eventId}&content.type.id=IFRAME`;
    const illegalContentUrl = eventUrl.includes('eventbrite')
        ? illegalContentUrlProd
        : illegalContentUrlTest;
    const linkText = intl.formatMessage({
        id: 'this form',
        defaultMessage: 'this form',
    });
    const link = (
        <a
            href={illegalContentUrl}
            rel="noopener noreferrer"
            target="_blank"
            title={linkText}
        >
            {linkText}
        </a>
    );
    const message = intl.formatMessage(
        {
            id: 'To report other categories of prohibited or illegal content, submit {link}',
            defaultMessage: 'To report other categories of prohibited or illegal content, submit {link}',
            description: 'context: To report other categories of prohibited or illegal content, submit "this form".',
        },
        {
            link: linkText,
        }
    );

    return (
        <p className={styles.dsaText} data-testid="reason_other-radio">
            {insertLinkIntoMessage(message, linkText, link)}.
        </p>
    );
};
